import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { ViveroGrupoEspecie } from './entity-viveros-grupo-especie.model';

export const entityViverosGrupoEspecieAdapter: EntityAdapter<ViveroGrupoEspecie> =
  createEntityAdapter<ViveroGrupoEspecie>({
    selectId: (model) => model.id,
    sortComparer: (a: ViveroGrupoEspecie, b: ViveroGrupoEspecie): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityViverosGrupoEspecieState
  extends EntityState<ViveroGrupoEspecie> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null;
}

export const initialState: EntityViverosGrupoEspecieState =
  entityViverosGrupoEspecieAdapter.getInitialState({
    isLoading: false,
    hasAddedSuccess: null,
    error: null
  });
